import * as React from "react";
import { Alert, CircularProgress, Typography } from "@mui/material";
import { useExternalSite } from "./hooks/useExternalSite";
import { EquipmentList } from "../../externals/partials/EquipmentList";

export const ExternalEquipmentsPage: React.FC = () => {
  const { site, equipments, loading, error } = useExternalSite();

  if (loading) return <CircularProgress sx={{ display: "block", m: "auto" }} />;
  if (error) return <Alert severity="error">{error}</Alert>;
  if (!site) return <Alert severity="warning">Site introuvable.</Alert>;

  return (
    <>
      <title>Trackency - Liste de vos Equipements</title>
      <Typography variant="h5" gutterBottom>
        Vos équipements — {site.name}
      </Typography>
      <EquipmentList equipments={equipments} />
    </>
  );
};
